/* eslint-disable */
//tslint:disable
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import {
  TGetChatsWidgetMicrofrontendModel,
  IGetChatsWidgetMicrofrontendRequest,
  IMappers,
  TGetChatsWidgetMicrofrontendResponse,
} from './types';

const defaultConfig = {
  apiType: 'public',
  assertStatusCodes: [200],
  method: 'GET',
  microserviceName: 'frontend-chats',
  pathApi: '/v2/get-chats-widget/',
  requestType: 'json',
  responseType: 'json',
} as TGetChatsWidgetMicrofrontendModel;

function createGetChatsWidgetMicrofrontendV2Model(
  parameters: IGetChatsWidgetMicrofrontendRequest,
): TGetChatsWidgetMicrofrontendModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetChatsWidgetMicrofrontendOptions<TResponse200> {
  httpApi: IHttpApi;
  parameters: IGetChatsWidgetMicrofrontendRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

async function fetchGetChatsWidgetMicrofrontendV2<TResponse200>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetChatsWidgetMicrofrontendOptions<TResponse200>): Promise<TResponse200 | TGetChatsWidgetMicrofrontendResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetChatsWidgetMicrofrontendV2Model(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMicrofrontendManifest);
    }
  }

  return { response, statusCode } as TGetChatsWidgetMicrofrontendResponse;
}
export { defaultConfig, createGetChatsWidgetMicrofrontendV2Model, fetchGetChatsWidgetMicrofrontendV2 };
